<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <div class="uk-grid uk-grid-small uk-margin-bottom">
                <div class="uk-width-4-5 uk-flex">
                    <div>
                        <ul class="uk-subnav uk-subnav-line">
                            <li :class="{'uk-active': !state.age}"><a href @click.prevent="set_state_value_and_reload('age', '')">Any Age</a></li>
                            <li :class="{'uk-active': state.age === 'New'}"><a href @click.prevent="set_state_value_and_reload('age', 'New')">New</a></li>
                            <li :class="{'uk-active': state.age === 'Prospective'}"><a href @click.prevent="set_state_value_and_reload('age', 'Prospective')">Prospective</a></li>
                            <li :class="{'uk-active': state.age === 'Languished'}"><a href @click.prevent="set_state_value_and_reload('age', 'Languished')">Languished</a></li>
                        </ul>
                        <!--
                        <ul class="uk-subnav uk-subnav-line">
                            <li :class="{'uk-active': !state.age}"><a href @click.prevent="set_state_value_and_reload('age', '')">All Ages</a></li>
                            <li :class="{'uk-active': state.age === 'Prospective'}"><a href @click.prevent="set_state_value_and_reload('age', 'Prospective')">Prospective</a></li>
                            <li :class="{'uk-active': state.age === 'Languished'}"><a href @click.prevent="set_state_value_and_reload('age', 'Languished')">Languished</a></li>
                        </ul>
                        //-->
                    </div>
                    <div>
                        <ul class="uk-subnav uk-subnav-line uk-margin-large-left">
                            <li :class="{'uk-active': !state.type_of_request}"><a href @click.prevent="set_state_value_and_reload('type_of_request', '')">All Types of Request</a></li>
                            <li
                                v-for="type_of_request in types_of_request"
                                :key="type_of_request.id"
                                :class="{'uk-active': state.type_of_request === type_of_request.id}"
                            >
                                <a href @click.prevent="set_state_value_and_reload('type_of_request', type_of_request.id)">
                                    {{ type_of_request.name }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="uk-width-1-5 uk-text-right">
                    <div class="uk-button-group uk-margin-right lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.mode === 'hours'}"
                            @click.prevent="set_state_value('mode', 'hours')"
                        >
                            Hours
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.mode === 'fee'}"
                            @click.prevent="set_state_value('mode', 'fee')"
                        >
                            Fee
                        </base-button>
                    </div>

                    <div class="uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 6}"
                            @click.prevent="set_scope(6)"
                        >
                            6 weeks
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 12}"
                            @click.prevent="set_scope(12)"
                        >
                            3 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 26}"
                            @click.prevent="set_scope(26)"
                        >
                            6 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 52}"
                            @click.prevent="set_scope(52)"
                        >
                            1 year
                        </base-button>
                    </div>
                </div>
            </div>

            <div class="uk-grid uk-grid-small uk-margin-bottom lam-graph">
                <div class="uk-width-1-1" style="position: relative;">
                    <prospective-projections-graph
                        ref="chart"
                        :chart-data="chart_data"
                        :y-max="ymax"
                        :field="state.mode"
                        style="height: 800px;"
                        @click="route_to_project"
                    />
                    <!--
                    <div class="uk-button-group lam-graph-toggles">
                        <base-button
                            flavor="link"
                            size="mini"
                            @click.prevent="datasets_set_visibility(false)"
                        >
                            Hide All
                        </base-button>
                        <base-button
                            flavor="link"
                            size="mini"
                            @click.prevent="datasets_set_visibility(true)"
                        >
                            Show All
                        </base-button>
                    </div>
                    //-->
                    <div
                        :class="{ 'uk-active': legend_visible }"
                        class="lam-graph-drawer"
                    >
                        <base-button
                            :flavor="legend_visible ? 'normal' : 'link'"
                            :color="legend_visible ? 'primary' : 'regular'"
                            size="mini"
                            @click.prevent="legend_visible = !legend_visible"
                        >
                            <open-icon :glyph="legend_visible ? 'map' : 'map-o'" />
                        </base-button>
                        <base-button
                            flavor="link"
                            size="mini"
                            title="Hide All"
                            @click.prevent="datasets_set_visibility(false)"
                        >
                            <open-icon glyph="check-square-o" />
                        </base-button>
                        <base-button
                            flavor="link"
                            size="mini"
                            title="Show All"
                            @click.prevent="datasets_set_visibility(true)"
                        >
                            <open-icon glyph="square-o" />
                        </base-button>
                        <div>
                            <ul>
                                <li
                                    v-for="(dataset, index) in chart_data.datasets"
                                    :key="dataset.project.id"
                                    :style="{ '--bg-color': dataset.backgroundColor }"
                                    :class="{ 'uk-disabled': !dataset_is_visible(index) }"
                                >
                                    <base-button
                                        flavor="link"
                                        size="mini"
                                        @click.prevent="dataset_toggle_visibility(index)"
                                    >
                                        {{ dataset.label }}
                                    </base-button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </report>
</template>

<script>
import is_big_report from "./IsBigReport"
import handles_projects from "./HandlesProjects"
import string_utilities from "../../mixins/StringUtilities"
import uses_color_palette from "../../mixins/UsesColorPalette"

import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"
import Report from "./Report.vue"
import ProspectiveProjectionsGraph from "./ProspectiveProjectionsGraph.js"

export default {
    mixins: [is_big_report, handles_projects, string_utilities, uses_color_palette],
    components: {
        BaseButton,
        OpenIcon,
        Report,
        ProspectiveProjectionsGraph
    },
    methods: {
        route_to_project (project_id, event) {
            this.route_to_record(project_id, event, "prospective_project")
        }
    },
    computed: {
        chart_data () {
            const data = { labels: [], datasets: [] }
            const range_start = this.$moment().startOf("week")
            const range_end = this.$moment(range_start).add(this.state.scope, "weeks")
            const palette = this.extended_palette
            let palette_index = 0

            if(this.report) {
                const project_datasets = {}
                const report_dataset = this.report.dataset
                Object.keys(report_dataset).forEach(date_string => {
                    const date = this.$moment(date_string)
                    if(date.isSameOrAfter(range_start) && date.isSameOrBefore(range_end)) {
                        data.labels.push(date.format("MMM Do"))

                        Object.keys(report_dataset[date_string]).forEach(project_id => {
                            project_id = parseInt(project_id)
                            if(!project_datasets[project_id]) {
                                const project = this.entity_record("project", parseInt(project_id)) || {}
                                const color = palette[palette_index % palette.length]
                                palette_index++

                                project_datasets[project_id] = {
                                    label: this.nibnut_filter("nibnut.smart-truncate", [project ? project.name : "", 30]),
                                    backgroundColor: color.background,
                                    borderColor: "#ffffff",
                                    borderWidth: 1,
                                    categoryPercentage: 0.9,
                                    barPercentage: 0.8,
                                    data: new Array(this.state.scope).fill(0),
                                    project: project,
                                    raw_data: new Array(this.state.scope).fill(null)
                                }
                            }
                            project_datasets[project_id].data[data.labels.length - 1] = report_dataset[date_string][project_id][this.state.mode]
                            project_datasets[project_id].raw_data[data.labels.length - 1] = report_dataset[date_string][project_id]
                        })
                    }
                })
                data.datasets = Object.values(project_datasets)

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.ymax = 0
                for(let loop = 0; loop < data.labels.length; loop++) {
                    let period_total = 0
                    data.datasets.forEach(dataset => {
                        period_total += parseFloat(dataset.data[loop]) || 0
                    })
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.ymax = Math.max(period_total, this.ymax)
                }
            }

            return data
        },
        types_of_request () {
            return this.dictionary("type_of_request")
        }
    },
    data () {
        return {
            report_id: "prospective_projections",

            default_state: {
                scope: 12, // nb_weeks
                mode: "hours", // hours or fee
                age: "",
                type_of_request: 0,
                version_id: 0
            }
        }
    }
}
</script>
